export const aicData = {
  heroTagline:
    "A next-generation B.Tech program that integrates AI model development, systems engineering, and large-scale computing infrastructure to prepare students for real-world AI deployment.",
  atGlance: [
    { label: "Program", value: "B.Tech (AIC)" },
    { label: "Duration", value: "4 years" },
    { label: "Total Credits", value: "140" },
    { label: "Focus", value: "AI + Systems + Infrastructure" },
  ],
  about:
    "Behind every AI application is a complex ecosystem of high-performance computing, large-scale servers, and advanced software systems, often running in data centers across the world. In this AIC program, students learn the complete lifecycle of AI applications, from developing AI models to deploying and running them on high-performance computing systems.",
  programPillars: [
    {
      title: "AI Models",
      description: "Machine learning, deep learning, and generative AI.",
    },
    {
      title: "Systems Engineering",
      description:
        "Operating systems, distributed systems, and performance optimization.",
    },
    {
      title: "Infrastructure",
      description: "Cloud, high-performance computing, and edge AI.",
    },
  ],
  whyProgram: [
    "India is rapidly investing in AI infrastructure and innovation. With strong government initiatives and increasing industry adoption, there is a rising demand for professionals who both develop AI models and build the systems that deploy them at scale, not just design algorithms.",
    "At present, there is a shortage of skilled engineers who understand both AI and the computing systems that support it. This program is designed to bridge that gap by combining AI expertise with systems and computing knowledge, enabling students to work across the complete AI lifecycle.",
    "Experienced faculty with expertise across AI, systems engineering, and large-scale computing guide students through both theoretical foundations and real-world applications. Industry experts contribute to teaching and curriculum design, ensuring the program remains aligned with current practices and deployment needs.",
    "Graduates of this program will be well-prepared for roles in AI development, including Machine Learning Engineer, NLP Engineer, and Computer Vision Engineer, as well as roles in AI systems, such as AI Engineer, AI Systems Engineer, ML Platform Engineer, GPU Development Engineer, MLOps Engineer, and Cloud Infrastructure Engineer.",
  ],
  keyFeatures: [
    {
      title: "Full AI Stack Focus",
      description:
        "Unlike traditional data science programs, AIC emphasizes the entire AI pipeline, from algorithm development to system deployment.",
    },
    {
      title: "Hardware-Software Co-design",
      description:
        "Gain expertise in both the software (AI algorithms) and the hardware (accelerators, distributed systems) needed for modern AI.",
    },
    {
      title: "System Engineering for AI",
      description:
        "Learn to build and manage the infrastructure required for training and deploying large-scale AI models.",
    },
    {
      title: "Industry-Ready Curriculum",
      description:
        "Faculty and industry experts shape courses to match current practices and real-world deployment needs.",
    },
  ],
  jobOpportunities: [
    "Machine Learning Engineer",
    "NLP Engineer",
    "Computer Vision Engineer",
    "AI Engineer",
    "AI Systems Engineer",
    "ML Platform Engineer",
    "GPU Development Engineer",
    "MLOps Engineer",
    "Cloud Infrastructure Engineer",
  ],
  aicVsDsai: {
    description:
      "The Data Science and AI (DSAI) program centers on data science, focusing on extracting insights using statistical analysis, preprocessing, feature engineering, visualization, and predictive modeling. The AIC program focuses on the hardware and software infrastructure needed to deploy and run AI applications at scale, including distributed systems, edge computing, and performance optimization. This opens opportunities in AI systems and infrastructure engineering.",
    programsNote:
      "IIIT Dharwad offers B.Tech programs in both AI pathways (DSAI and AIC), along with Computer Science and Engineering and Electronics and Communication Engineering.",
    highlights: [
      {
        title: "DSAI focus",
        description: "Data pipelines, modeling, and decision analytics.",
      },
      {
        title: "AIC focus",
        description: "Systems, compute, and deployment at scale.",
      },
      {
        title: "Shared foundation",
        description: "Strong math, programming, and AI core courses.",
      },
    ],
    dsaiCoreCredits: 32,
    aicCoreCredits: 38,
    dsaiCourses: [
      { name: "Data Curation Techniques", credits: 3 },
      { name: "Statistical Programming", credits: 2 },
      { name: "Data Handling and Visualization", credits: 3 },
      { name: "Artificial Intelligence", credits: 4 },
      { name: "Machine Learning", credits: 4 },
      { name: "Database Management and Warehousing", credits: 4 },
      { name: "Data Security and Privacy", credits: 4 },
      { name: "Big Data Analytics", credits: 4 },
      { name: "Deep Learning", credits: 4 },
    ],
    aicCourses: [
      { name: "Computer Systems and Organization", credits: 3 },
      { name: "Introduction to AI and Computing", credits: 2 },
      { name: "Analysis", credits: 3 },
      { name: "Computing Paradigms", credits: 3 },
      { name: "Mathematics for AIC", credits: 3 },
      { name: "Machine Learning Paradigms", credits: 4 },
      { name: "Edge Computing AI Systems", credits: 3 },
      { name: "Computational Tools for AI", credits: 2 },
      { name: "Numerical Analysis", credits: 2 },
      { name: "Cloud AI systems", credits: 3 },
      { name: "Deep Learning", credits: 4 },
      { name: "Reinforcement Learning", credits: 3 },
      { name: "High-Performance AI Systems", credits: 3 },
    ],
  },
  curriculum: [
    {
      semester: 1,
      totalCredits: 18,
      courses: [
        { name: "Probability", credits: 2, type: "Maths and Stats" },
        { name: "Statistics", credits: 2, type: "Maths and Stats" },
        { name: "Open Elective-I", credits: 2, type: "OE" },
        {
          name: "HSS/IE-English Language & communication",
          credits: 3,
          type: "HSS/IE",
        },
        {
          name: "Problem Solving through Programming",
          credits: 4,
          type: "Engineering Core",
        },
        { name: "Computer Systems and Organization", credits: 3, type: "AIC" },
        { name: "Introduction to AI and Computing", credits: 2, type: "AIC" },
      ],
    },
    {
      semester: 2,
      totalCredits: 19,
      courses: [
        { name: "Linear Algebra", credits: 2, type: "Maths and Stats" },
        { name: "Optimization", credits: 2, type: "Maths and Stats" },
        { name: "Analysis", credits: 3, type: "AIC" },
        { name: "Open Elective-II", credits: 2, type: "OE" },
        { name: "HSS/IE-Economics", credits: 3, type: "HSS/IE" },
        { name: "Computing Paradigms", credits: 3, type: "AIC" },
        {
          name: "Data Structures and Algorithms",
          credits: 4,
          type: "Engineering Core",
        },
      ],
    },
    {
      semester: 3,
      totalCredits: 21,
      courses: [
        { name: "Multivariate Calculus", credits: 2, type: "Maths and Stats" },
        { name: "Differential Equation", credits: 2, type: "Maths and Stats" },
        { name: "Mathematics for AIC", credits: 3, type: "AIC" },
        { name: "Machine Learning Paradigms", credits: 4, type: "AIC" },
        { name: "Edge Computing AI Systems", credits: 3, type: "AIC" },
        { name: "Computational Tools for AI", credits: 2, type: "AIC" },
        { name: "Open Elective-III", credits: 2, type: "OE" },
        { name: "HSS/IE", credits: 3, type: "HSS/IE" },
      ],
    },
    {
      semester: 4,
      totalCredits: 20,
      courses: [
        { name: "Numerical Analysis", credits: 2, type: "AIC" },
        { name: "Cloud AI systems", credits: 3, type: "AIC" },
        { name: "Deep Learning", credits: 4, type: "DSAI/AIC" },
        { name: "Reinforcement Learning", credits: 3, type: "AIC" },
        { name: "High-Performance AI Systems", credits: 3, type: "AIC" },
        { name: "Open Elective-IV", credits: 2, type: "OE" },
        { name: "HSS/IE", credits: 3, type: "HSS/IE" },
      ],
    },
    {
      semester: 5,
      totalCredits: 22,
      courses: [
        {
          name: "HSS/Innovation & Entrepreneurship",
          credits: 3,
          type: "HSS/IE",
        },
        { name: "Discipline Elective-I", credits: 3, type: "DE" },
        { name: "Discipline Elective-II", credits: 4, type: "DE" },
        { name: "Discipline Elective-III", credits: 4, type: "DE" },
        {
          name: "Open Elective-V/Development Projects/ R&D Projects",
          credits: 4,
          type: "OE",
        },
        {
          name: "Open Elective-VI/Development Projects/ R&D Projects",
          credits: 4,
          type: "OE",
        },
      ],
    },
    {
      semester: 6,
      totalCredits: 21,
      courses: [
        {
          name: "HSS/Innovation & Entrepreneurship",
          credits: 3,
          type: "HSS/IE",
        },
        { name: "Discipline Elective-IV", credits: 3, type: "DE" },
        { name: "Discipline Elective-V", credits: 3, type: "DE" },
        { name: "Discipline Elective-VI", credits: 4, type: "DE" },
        {
          name: "Open Elective-VII/Development Projects/ R&D Projects",
          credits: 4,
          type: "OE",
        },
        {
          name: "Open Elective-VIII/Development Projects/ R&D Projects",
          credits: 4,
          type: "OE",
        },
      ],
    },
    {
      semester: 7,
      totalCredits: 11,
      courses: [
        {
          name: "HSS/Innovation & Entrepreneurship",
          credits: 3,
          type: "HSS/IE",
        },
        {
          name: "Open Elective-IX/Development Projects/ R&D Projects",
          credits: 4,
          type: "OE",
        },
        {
          name: "Open Elective-X/Development Projects/ R&D Projects",
          credits: 4,
          type: "OE",
        },
      ],
    },
    {
      semester: 8,
      totalCredits: 8,
      courses: [{ name: "Electives/Major Project", credits: 8, type: "OE" }],
    },
  ],
  faqs: [
    {
      question: "How is AIC different from DSAI?",
      answer:
        "AIC focuses on the full AI stack, including model development, systems engineering, and computing infrastructure for deployment at scale. DSAI focuses mainly on building AI models for data analysis and applications, with less emphasis on the underlying systems and hardware.",
    },
    {
      question: "Will I still learn AI models?",
      answer:
        "Yes. You will learn how to develop AI and machine learning models, along with how to deploy and run them efficiently on real systems.",
    },
    {
      question: "What companies hire AIC graduates?",
      answer:
        "Technology companies, cloud providers, semiconductor companies, and startups working in AI, such as Google, Microsoft, Amazon, NVIDIA, and Intel, and startups working in AI."
    },
    {
      question: "Is this future-proof?",
      answer:
        "Yes. As AI adoption grows, there is increasing demand for engineers who can not only build models but also run them efficiently on large-scale systems.",
    },
    {
      question: "Will I get jobs in AI?",
      answer:
        "Yes. You will get jobs in AI development roles such as Machine Learning Engineer, NLP Engineer, and Computer Vision Engineer. By pursuing BTech in AI and Computing you will also get opportunities in the system roles such as AI engineer, AI Systems Engineer, ML Platform Engineer, GPU Development Engineer, MLOps Engineer, and Cloud Infrastructure Engineer.",
    },
  ],
  forParents:
    "This program provides a future-ready career path with strong job prospects in a rapidly growing field. It combines core engineering knowledge with cutting-edge AI and computing skills, ensuring graduates are industry-ready from day one.",
  outcomesLine:
    "Graduates are equipped for both AI model development and AI systems engineering roles across industry and research labs.",
  curriculumNote:
    "Courses tagged as AIC are part of the Discipline Core for the B.Tech in AI and Computing program.",
  totalCredits: 140,
  facultyLink: "https://iiitdwd.ac.in/academics/faculty/",
  cta: {
    primary: {
      label: "Contact Programme Coordinator",
      href: "mailto:nataraj@iiitdwd.ac.in",
    },
    secondary: {
      label: "View Program Details",
      href: "#curriculum",
    },
  },
  contact: {
    role: "Programme coordinator",
    name: "Dr. Nataraj K S",
    email: "nataraj@iiitdwd.ac.in",
  },
};
